function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 4.42,
    height: 5.66,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 2.83
  }, "\n        Alpine\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5.66,
    width: 4.42,
    height: 16.33,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 13.825
  }, "\n        Sierra\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 21.99,
    width: 4.42,
    height: 35.88,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.884
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 39.93
  }, "\n        Modoc\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 57.87,
    width: 4.42,
    height: 45.54,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 80.64
  }, "\n        Mono\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 103.41,
    width: 4.42,
    height: 52.56,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.6314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 129.69
  }, "\n        Trinity\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 155.97,
    width: 4.42,
    height: 52.71,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 182.325
  }, "\n        Colusa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 208.68,
    width: 4.42,
    height: 69.56,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.105
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 243.46
  }, "\n        Inyo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 278.24,
    width: 4.42,
    height: 77.83,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.4911111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 317.15500000000003
  }, "\n        Del_Norte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 356.07,
    width: 4.42,
    height: 79.11,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.5525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 395.625
  }, "\n        Mariposa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 435.18,
    width: 4.42,
    height: 80.68,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.884
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 475.52
  }, "\n        Glenn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 515.86,
    width: 4.42,
    height: 90.68,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 0.7366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 561.2
  }, "\n        Plumas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 606.54,
    width: 4.42,
    height: 93.46,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.7366666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 2.21,
    y: 653.27
  }, "\n        Lassen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 0,
    width: 18.84,
    height: 36.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 13.84,
    y: 18.025
  }, "\n        Amador\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.25,
    y: 0,
    width: 19.82,
    height: 36.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 1.982
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.16,
    y: 18.025
  }, "\n        San_Benito\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 43.07,
    y: 0,
    width: 21.4,
    height: 36.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.35
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.769999999999996,
    y: 18.025
  }, "\n        Yuba\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64.47,
    y: 0,
    width: 21.6,
    height: 36.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 75.27,
    y: 18.025
  }, "\n        Siskiyou\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86.06,
    y: 0,
    width: 23.46,
    height: 36.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.606666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.79,
    y: 18.025
  }, "\n        Calaveras\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 109.52,
    y: 0,
    width: 24.6,
    height: 36.05,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1000000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 121.82,
    y: 18.025
  }, "\n        Tehama\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.11,
    y: 0,
    width: 25.67,
    height: 36.05,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.4175
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 146.94500000000002,
    y: 18.025
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 159.78,
    y: 0,
    width: 27.19,
    height: 36.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.39875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.375,
    y: 18.025
  }, "\n        Tuolumne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 186.97,
    y: 0,
    width: 33.07,
    height: 36.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.511666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 203.505,
    y: 18.025
  }, "\n        Sutter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220.04,
    y: 0,
    width: 35.13,
    height: 36.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.026000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.605,
    y: 18.025
  }, "\n        Kings\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.16,
    y: 0,
    width: 38.86,
    height: 36.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.50625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 274.59,
    y: 18.025
  }, "\n        Imperial\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.02,
    y: 0,
    width: 40.24,
    height: 36.05,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.0055555555555555
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 314.14,
    y: 18.025
  }, "\n        Mendocino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.26,
    y: 0,
    width: 42.54,
    height: 36.05,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.008333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 355.53,
    y: 18.025
  }, "\n        Madera\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 376.8,
    y: 0,
    width: 55.5,
    height: 36.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.008333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 404.55,
    y: 18.025
  }, "\n        Nevada\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 432.3,
    y: 0,
    width: 59.63,
    height: 36.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.0125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.115,
    y: 18.025
  }, "\n        Napa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.93,
    y: 0,
    width: 64.06,
    height: 36.05,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.50625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 523.96,
    y: 18.025
  }, "\n        Humboldt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 555.99,
    y: 0,
    width: 64.14,
    height: 36.05,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.008333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.0600000000001,
    y: 18.025
  }, "\n        Merced\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 620.13,
    y: 0,
    width: 79.87,
    height: 36.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.0125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.065,
    y: 18.025
  }, "\n        Yolo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 36.05,
    width: 66.97,
    height: 43.23,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.204999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 57.66499999999999
  }, "\n        Shasta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 79.27,
    width: 66.97,
    height: 50.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.588888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 104.41999999999999
  }, "\n        El_Dorado\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 129.57,
    width: 66.97,
    height: 53,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.6
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 156.07
  }, "\n        Butte\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 182.57,
    width: 66.97,
    height: 56.88,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 211.01
  }, "\n        Tulare\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 239.46,
    width: 66.97,
    height: 68.86,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.697
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 273.89
  }, "\n        Santa_Cruz\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 308.32,
    width: 66.97,
    height: 69.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.37125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 343.3
  }, "\n        Monterey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 378.28,
    width: 66.97,
    height: 71.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.464666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 414.16999999999996
  }, "\n        San_Luis_Obispo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 450.05,
    width: 66.97,
    height: 75.78,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.394
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 487.94
  }, "\n        Marin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 525.83,
    width: 66.97,
    height: 87.06,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.697
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 569.36
  }, "\n        Stanislaus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.42,
    y: 612.89,
    width: 66.97,
    height: 87.11,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.161666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.905,
    y: 656.4449999999999
  }, "\n        Solano\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.38,
    y: 36.05,
    width: 68.37,
    height: 91.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.395000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 105.565,
    y: 81.935
  }, "\n        Placer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.76,
    y: 36.05,
    width: 69,
    height: 91.77,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3076923076923075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.26,
    y: 81.935
  }, "\n        Santa_Barbara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.76,
    y: 36.05,
    width: 82.73,
    height: 91.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.520909090909091
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 250.125,
    y: 81.935
  }, "\n        San_Joaquin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 291.49,
    y: 36.05,
    width: 90.41,
    height: 91.77,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.068333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 336.695,
    y: 81.935
  }, "\n        Sonoma\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 381.9,
    y: 36.05,
    width: 91.4,
    height: 91.77,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 22.85
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 427.59999999999997,
    y: 81.935
  }, "\n        Kern\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 473.3,
    y: 36.05,
    width: 107.57,
    height: 91.77,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.295
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 527.085,
    y: 81.935
  }, "\n        Fresno\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.87,
    y: 36.05,
    width: 119.13,
    height: 91.77,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.196666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.435,
    y: 81.935
  }, "\n        San_Mateo\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.38,
    y: 127.81,
    width: 108.51,
    height: 113.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.501428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.63499999999999,
    y: 184.535
  }, "\n        Ventura\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.38,
    y: 241.27,
    width: 108.51,
    height: 127.37,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.346923076923078
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.63499999999999,
    y: 304.95500000000004
  }, "\n        San_Francisco\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.38,
    y: 368.63,
    width: 108.51,
    height: 150.78,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.0425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.63499999999999,
    y: 444.02
  }, "\n        Contra_Costa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71.38,
    y: 519.41,
    width: 108.51,
    height: 180.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.851
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.63499999999999,
    y: 609.7049999999999
  }, "\n        Sacramento\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.9,
    y: 127.81,
    width: 168.31,
    height: 130.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.288571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.055,
    y: 192.82999999999998
  }, "\n        San_Bernardino\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 348.21,
    y: 127.81,
    width: 172.39,
    height: 130.04,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.577142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.405,
    y: 192.82999999999998
  }, "\n        Alameda\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 520.6,
    y: 127.81,
    width: 179.4,
    height: 130.04,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.448888888888888
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.3000000000001,
    y: 192.82999999999998
  }, "\n        Riverside\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.9,
    y: 257.86,
    width: 148.45,
    height: 161.6,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 13.495454545454544
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.125,
    y: 338.66
  }, "\n        Santa_Clara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.9,
    y: 419.45,
    width: 148.45,
    height: 280.55,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.741666666666664
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 254.125,
    y: 559.725
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.34,
    y: 257.86,
    width: 371.66,
    height: 120,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.333333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.17,
    y: 317.86
  }, "\n        San_Diego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 328.34,
    y: 377.86,
    width: 371.66,
    height: 322.14,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.285454545454545
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 514.17,
    y: 538.9300000000001
  }, "\n        Los_Angeles\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2008);
export default __webpack_public_path__ + "static/media/2008.8b938b9e0e9dced6336761af6fd69858.svg";
export { ForwardRef as ReactComponent };